<template>
  <v-container grid-list-xl class="pa-0">
    <v-row wrap>
      <v-col cols="12">
        <FilterPengurus @filter="filter" class="px-5" />

        <v-row class="mx-3">
          <!-- <v-col cols="12" class="ml-3" v-show="current_user.lingkup.tingkat == 1">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn href="" v-bind="attrs" v-on="on" class="elevation-7 text-capitalize white--text amber darken-1">
                  UNDUH <v-icon class="ml-2" small color="white">mdi-arrow-down-drop-circle-outline</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="rekapKota">
                  <v-list-item-title class=" purple--text text--darken-4">REKAP KOTA</v-list-item-title>
                </v-list-item>
                <v-list-item @click="rekapKecamatan">
                  <v-list-item-title class=" purple--text text--darken-4">REKAP KECAMATAN</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col> -->
          <v-col cols="12" class="mb-0 pb-0 title">{{ item.keterangan }}</v-col>
          <v-col cols="12" sm="6" md="4" lg="4" v-for="o in item.dokumen" :key="o.index">
            <v-card class="mx-auto my-3 text-center flexcard" style="height:100%">
              <template slot="progress">
                <v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
              </template>

              <v-icon size="150" color="success">mdi-file</v-icon>

              <div class="text-center caption pb-0 mb-0 mx-3 font-weight-bold amber rounded mt-4 pa-1">{{ o.keterangan }}</div>

              <v-divider class="ma-2"></v-divider>

              <v-card-actions style="margin-bottom:0">
                <v-spacer></v-spacer>
                <v-btn v-if="o.berkas" color="orange" class="white--text" @click="add(o, 'ubah')"> Ubah <v-icon class="ml-2" small color="white">mdi-pencil</v-icon> </v-btn>

                <v-btn v-if="o.berkas" @click="unduh(o)" class="elevation-7 text-capitalize white--text teal darken-1 mx-3">
                  UNDUH <v-icon class="ml-2" small color="white">mdi-download</v-icon>
                </v-btn>

                <v-btn v-else color="info" class="white--text" @click="add(o)"> Tambah <v-icon class="ml-2" small color="white">mdi-plus</v-icon> </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <ChangeDlg ref="dlg" />
    </v-row>
  </v-container>
</template>

<script>
const lc = window.localStorage;
const TOKEN = "siapbbjatimtoken";
import ChangeDlg from "../../dokumen/components/Form.vue";
import FilterPengurus from "@/filter/FilterPengurus.vue";

export default {
  components: {
    ChangeDlg,
    FilterPengurus
  },
  data() {
    return {
      item: {
        jabatan: []
      },
      items: [],
      filtered: {
        propinsi_id: null,
        kota_id: null,
        kecamatan_id: null,
        kelurahan_id: null
      },
      wilayah: null,
      tingkat: null,
      itemMapels: [],
      peran: null,
      textSearch: null,
      page: null,
      cp: 1,
      headers: [{ text: "", align: "left", value: "" }, { text: "", align: "left", value: "" }, { text: "", align: "left", value: "" }, { text: "", sortable: false }],
      more_menu: [
        // eslint-disable-next-line
        {
          title: "Detil Anggota",
          click: (i, o) => this.getDetil(o)
        },
        {
          title: "Ubah",
          click: (i, o) => this.edit(o),
          check: (i, o) => o.nomer_anggota == "" && !(this.current_user.peran && this.current_user.peran.id == 2)
        },
        {
          title: "Hapus",
          click: (i, o) => this.hapus(o),
          check: (i, o) => o.nomer_anggota == ""
        }
      ]
    };
  },
  mounted() {
    this.wilayah = this.current_user && this.current_user.lingkup.id;
    this.tingkat = this.current_user && this.current_user.lingkup.tingkat;
    this.load();
  },
  methods: {
    load() {
      return this.$store
        .dispatch("dokumen/get", {
          params: {
            wilayah_id: this.wilayah,
            tingkat: this.tingkat
          }
        })
        .then(res => {
          this.item = res;
        })
        .catch(e => e);
    },
    rekapKota() {
      var token = lc.getItem(TOKEN);
      return this.$store
        .dispatch("laporan/pengurusRekapKota", {
          params: {
            access_token: token
          }
        })
        .catch(e => e);
    },
    rekapKecamatan() {
      var token = lc.getItem(TOKEN);
      return this.$store
        .dispatch("laporan/pengurusRekapKecamatan", {
          params: {
            access_token: token
          }
        })
        .catch(e => e);
    },

    filter(data) {
      this.filtered = data;
      if (this.filtered.kelurahan_id) {
        this.wilayah = this.filtered.kelurahan_id;
        this.tingkat = 5;
      } else if (this.filtered.kecamatan_id) {
        this.wilayah = this.filtered.kecamatan_id;
        this.tingkat = 4;
      } else if (this.filtered.kota_id) {
        this.wilayah = this.filtered.kota_id;
        this.tingkat = 3;
      } else if (this.filtered.propinsi_id) {
        this.wilayah = this.filtered.propinsi_id;
        this.tingkat = 2;
      } else {
        this.wilayah = this.current_user && this.current_user.lingkup.id;
        this.tingkat = this.current_user && this.current_user.lingkup.tingkat;
      }
      this.load();
    },

    getDetil(item) {
      this.$refs.detailDlg.open(item);
    },
    add(o, isEdit) {
      this.$refs.dlg.open(o, this.wilayah, this.tingkat, isEdit).then(() => {
        this.load();
      });
    },
    unduh(item) {
      this.$confirm(
        `Apakah Anda yakin akan mengunduh dokumen ini ?<br>
        <div class="mt-2 title grow text-center">
           ${item.keterangan} <br>
        </div>
      `
      )
        .then(() => {
          // window.open(this.preview.kta_pdf.origin, "_blank");
          this.$store
            .dispatch("warga/unduh", item)
            .then(() => {
              this.$info("Data berhasil diunduh");
            })
            .then(() => this.load())
            .catch(e => e);
        })
        .catch(e => e);
    },

    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load();
      });
    },
    link(item) {
      window.open(item.link, "_blank");
    },
    hapus(item) {
      this.$confirm(
        `Apakah Anda yakin akan menghapus data dokumen ini ?<br>
        <div class="mt-2 title grow text-center">
          ${item.nama}<br>
        </div>`,
        {
          cancelOnly: item.laporan_accepted_count > 0 ? true : false
        }
      )
        .then(() => this.$store.dispatch("dokumen/drop", item))
        .then(() => {
          this.$info("Data Anggota " + item.nama + " berhasil dihapus");
        })
        .then(() => this.load())
        .catch(e => e);
    }
  },
  watch: {}
};
</script>
<style>
.flexcard {
  display: flex;
  flex-direction: column;
}
</style>
